import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";

const adminToken = secureStorage.getItem("adminToken");
const API_URL = "/admin/local/division";

const headers = {
  Authorization: `Bearer ${adminToken}`,
  "Content-Type": "application/json",
};

const initialFormData = {
  id: null,
  divisionName: "",
  countryId: "",
  status: 1,
};

export const viewDivision = async (setDivisionData, setLoading) => {
  if (setLoading) setLoading(true);

  try {
    const res = await axiosInstance.get(API_URL, { headers });
    setDivisionData(res.data.data || []);
    return true;
  } catch (error) {
    console.error("View division error:", error);
    toast.error(error.response?.data?.message || "Failed to fetch divisions");
    return false;
  } finally {
    if (setLoading) setLoading(false);
  }
};

export const addDivision = async (
  FormData,
  setFormData,
  setDivisionData,
  setLoading,
) => {
  try {
    const res = await axiosInstance.post(API_URL, FormData, {
      headers,
    });

    if (res.data.message === "Division added successfully") {
      toast.success("Division added successfully");
      setFormData({ ...initialFormData });
      await viewDivision(setDivisionData, setLoading);
      return true;
    }

    toast.error(res.data.message || "Failed to add division");
    return false;
  } catch (error) {
    console.error("Add division error:", error);
    toast.error(error.response?.data?.message || "Failed to add division");
    return false;
  }
};

export const updateDivision = async (
  FormData,
  setFormData,
  setDivisionData,
  setLoading,
) => {
  try {
    const res = await axiosInstance.put(API_URL, FormData, {
      headers,
    });

    if (res.data.message === "Division updated successfully") {
      toast.success("Division updated successfully");
      setFormData({ ...initialFormData });
      await viewDivision(setDivisionData, setLoading);
      return true;
    }

    toast.error(res.data.message || "Failed to update division");
    return false;
  } catch (error) {
    console.error("Update division error:", error);
    toast.error(error.response?.data?.message || "Failed to update division");
    return false;
  }
};

export const deleteDivision = async (id, setDivisionData, setLoading) => {
  try {
    const res = await axiosInstance.delete(API_URL, {
      headers,
      data: { id },
    });

    if (res.data.message === "Division deleted successfully") {
      toast.success("Division deleted successfully");
      await viewDivision(setDivisionData, setLoading);
      return true;
    }

    toast.error(res.data.message || "Failed to delete division");
    return false;
  } catch (error) {
    console.error("Delete division error:", error);
    toast.error(error.response?.data?.message || "Failed to delete division");
    return false;
  }
};
